import React, { useState, useEffect } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import styles from "./stylesAdmin.module.css"
import { ReparticionGde  } from "../../types/interfaces";
import { useLoading } from "../../components/LoadingContext";

interface AddReparticionGdeModalProps {
  show: boolean;
  onHide: () => void;
  showNotification: (message: string, variant: "success" | "danger") => void;
  onAddItem?: (item: any) => void;
}

export default function AddReparticionGdeModal({
  show,
  onHide,
  showNotification,
  onAddItem,
}: AddReparticionGdeModalProps) {
  const { setLoading } = useLoading();
  const [formData, setFormData] = useState<any>({});
  // const [reparticionesGde, setReparticionesGde] = useState<ReparticionGde[]>([]);
  const [errors, setErrors] = useState<any>({});

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const [reparticionesGdeResponse] = await Promise.all([
  //         fetch(`${process.env.REACT_APP_API_URL}/api/admin/allReparticionesGde`),
  //       ]);

  //       if (!reparticionesGdeResponse.ok) {
  //         throw new Error("Network response was not ok");
  //       }

  //       const [reparticionesGdeData] = await Promise.all([
  //         reparticionesGdeResponse.json(),
  //       ]);

  //       setReparticionesGde(reparticionesGdeData);
  //     } catch (error) {
  //       console.error("Failed to fetch data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [setLoading]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors: any = {};
    let hasErrors = false;

    const hashSymbolPattern = /#/;

    if (!formData.nombre) {
        newErrors.nombre = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (formData.nombre.length < 6) {
        newErrors.nombre = "Este campo debe tener al menos 6 caracteres.";
        hasErrors = true;
    } else if (!hashSymbolPattern.test(formData.nombre)) {
        newErrors.nombre = "Este campo debe contener al menos un símbolo '#'";
        hasErrors = true;
    }

    setErrors(newErrors);
    return !hasErrors;
};


  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    const transformedData = {
        nombre: formData.nombre
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/createReparticionGde`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transformedData),
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error('Failed to add reparticion gde');
      }

      const addedReparticionGde = await response.json();
  
      const reparticionGdeDetailsResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/reparticionGde/${addedReparticionGde.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      const reparticionGdeDetails = await reparticionGdeDetailsResponse.json();

      showNotification("Repartición GDE añadida con éxito", "success");
      setFormData({});
      onHide();
      if (onAddItem) onAddItem(reparticionGdeDetails);
    } catch (error) {
      showNotification("Error al añadir repartición GDE", "danger");
      console.error('Error adding reparticion:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} className={styles.modalContainer}>
      <Form onSubmit={handleSubmit}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Agregar Repartición GDE</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
          <FloatingLabel controlId="floatingInputNombre" label="Nombre" className="mb-3">
            <Form.Control type="text" placeholder="Nombre" name="nombre" onChange={handleInputChange} value={formData.nombre || ""} />
          </FloatingLabel>
          {errors.nombre && <div className={styles.errors}>{errors.nombre}</div>}
          </Modal.Body>
          <Modal.Footer className={styles.modalFooter}>
          <Button variant="primary" type="submit">Aceptar</Button>
          </Modal.Footer>
        </Form>
    </Modal>
  );
}
